import { render, staticRenderFns } from "./RegisterButton.vue?vue&type=template&id=590741d1&"
import script from "./RegisterButton.vue?vue&type=script&lang=js&"
export * from "./RegisterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports